export const SHIFT_TABLE_ZOOM_MIN = 0.85;
export const SHIFT_TABLE_ZOOM_DEFAULT = 1;
export const SHIFT_TABLE_ZOOM_MAX = 1.6;
export const SHIFT_TABLE_ZOOM_STEP = 0.1;
export const SHIFT_TABLE_ZOOM_STORAGE_KEY = "five.shiftWorktableZoom.v1";

export function normalizeShiftTableZoom(value) {
  if (value === null || value === undefined || String(value).trim() === "") {
    return SHIFT_TABLE_ZOOM_DEFAULT;
  }
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return SHIFT_TABLE_ZOOM_DEFAULT;
  const clamped = Math.min(SHIFT_TABLE_ZOOM_MAX, Math.max(SHIFT_TABLE_ZOOM_MIN, numericValue));
  return Math.round(clamped * 100) / 100;
}

export function adjustShiftTableZoom(currentZoom, direction) {
  const delta = direction === "out" ? -SHIFT_TABLE_ZOOM_STEP : SHIFT_TABLE_ZOOM_STEP;
  return normalizeShiftTableZoom(normalizeShiftTableZoom(currentZoom) + delta);
}

export function calculatePinchZoom({ startZoom, startDistance, currentDistance }) {
  const initialDistance = Number(startDistance);
  const nextDistance = Number(currentDistance);
  if (!Number.isFinite(initialDistance) || initialDistance <= 0 || !Number.isFinite(nextDistance)) {
    return normalizeShiftTableZoom(startZoom);
  }
  return normalizeShiftTableZoom(normalizeShiftTableZoom(startZoom) * (nextDistance / initialDistance));
}

export function calculatePinchContentPosition({ scrollOffset, viewportPosition, zoom }) {
  const scroll = Number(scrollOffset);
  const viewport = Number(viewportPosition);
  if (!Number.isFinite(scroll) || !Number.isFinite(viewport)) return 0;
  return Math.max(0, scroll + viewport / normalizeShiftTableZoom(zoom));
}

export function calculateZoomedScrollOffset({ contentPosition, viewportPosition, zoom }) {
  const content = Number(contentPosition);
  const viewport = Number(viewportPosition);
  if (!Number.isFinite(content) || !Number.isFinite(viewport)) return 0;
  return Math.max(0, content - viewport / normalizeShiftTableZoom(zoom));
}

export function getTouchGeometry(touches) {
  if (!touches || touches.length < 2) return null;
  const first = touches[0];
  const second = touches[1];
  const deltaX = Number(second.clientX) - Number(first.clientX);
  const deltaY = Number(second.clientY) - Number(first.clientY);
  const distance = Math.hypot(deltaX, deltaY);
  if (!Number.isFinite(distance) || distance <= 0) return null;
  return {
    distance,
    midpointX: (Number(first.clientX) + Number(second.clientX)) / 2,
    midpointY: (Number(first.clientY) + Number(second.clientY)) / 2,
  };
}
